import { shell } from '../app';
import { getSnapshot, onStoreChange } from '../data/store';
import { isDesktop } from '../ui/breakpoint';
import { input, linkBtn } from '../ui/components';
import { h, replaceChildren } from '../ui/dom';
import type { View } from '../ui/router';
import { pipelineDeskView } from './desk/pipelineBoard';
import { pipelineSections } from './pipeline/sections';

const phonePipelineView: View = ({ root }) => {
  shell.setChrome(true);
  shell.setTitle('Pipeline', {
    action: h(
      'div',
      { class: 'stack-h stack-h--tight' },
      linkBtn('Reports', '#/dashboard?from=pipeline', { variant: 'subtle', size: 'sm' }),
      linkBtn('+ New', '#/leads/new', { variant: 'subtle', size: 'sm' }),
    ),
  });
  let query = '';
  const list = h('div', { class: 'pipeline' });
  const search = input({
    type: 'search',
    placeholder: 'Search leads…',
    enterkeyhint: 'search',
    class: 'input--search',
    onInput: (v) => {
      query = v;
      void render();
    },
  });
  root.appendChild(
    h('div', { class: 'page page--pipeline' }, h('div', { class: 'searchbar' }, search), list),
  );

  const render = async () => replaceChildren(list, pipelineSections(await getSnapshot(), query));

  void render();
  return onStoreChange(() => void render());
};

/** On a computer the pipeline is a board of stage columns (D65); on the phone the grouped list. */
export const pipelineView: View = (ctx) => (isDesktop() ? pipelineDeskView(ctx) : phonePipelineView(ctx));
